import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)

export default new Vuex.Store({
	state: {
		status: '',
		token: localStorage.getItem('token') || '',
		userID: '',
		userDetails: {}
	},
	mutations: {
		auth_request(state) {
			state.status = 'loading'
		},
		auth_success(state, token, userID) {
			state.status = 'success'
			state.token = token
			state.userID = userID
		},
		auth_error(state) {
			state.status = 'error'
		},
		logout(state) {
			state.status = ''
			state.token = ''
		},
		loadUserData(state, payload){
      state.userDetails = payload
  	}
	},
	actions: {
		login({
			commit, dispatch
		}, user) {
			return new Promise((resolve, reject) => {
				let that = this
				that.commit('auth_request')
				axios({
						url: Vue.prototype.$endpoint + 'portal/login',
						data: user,
						method: 'POST'
					})
					.then(resp => {
						const token = resp.data.token
						const userID = resp.data.user
						localStorage.setItem('token', token)
						
						axios.defaults.headers.common['Authorization'] = 'JWT ' + token
						that.commit('auth_success', token, userID)

						axios.get(Vue.prototype.$endpoint + 'management/user/').then((response)=>{
							that.commit('loadUserData', response.data[0])
						})

						resolve(resp)
					})
					.catch(err => {
						that.commit('auth_error')
						localStorage.removeItem('token')
						reject(err)
					})
			})
		},
		getUserData(){
			console.log()
			let that = this
      axios.get(Vue.prototype.$endpoint + 'management/user/').then((response)=>{
				that.commit('loadUserData', response.data[0])
      })
    },
		logout({
			commit
		}) {
			let that = this
			return new Promise((resolve, reject) => {
				that.commit('logout')
				localStorage.removeItem('token')
				delete axios.defaults.headers.common['Authorization']
				resolve()
			})
		}
	},
	getters: {
		isLoggedIn: state => !!state.token,
		authStatus: state => state.status,
	}
})